import { sanitizeName } from './sanitize-name'

// OSS 上导出 shape 的存储路径（相对 storage 根）：
//   ProjectOssStorageKey 由 buildOssProjectPath 计算
//   <ProjectOssStorageKey>/<assetName>_<assetId>/<variant>_<shapeId>
export const buildOssShapePath = (
  ProjectOssStorageKey: string,
  assetName: string,
  assetId: string,
  shapeId: string,
  shapeVariant: string,
): string => {
  const leaf = `${shapeVariant}_${shapeId}`
  return `${ProjectOssStorageKey}/${sanitizeName(assetName)}_${assetId}/${leaf}`
}
